import { officeIsAppointmentItem, officeIsMessageItem } from './office-mail-mode'
import { officeEventAttendees, officeEventAttendeesEmailAddresses } from './office-events'
import { officeMailRecipients, officeMailRecipientsEmailAddresses } from './office-message'

async function officeRecipients(): Promise<Office.EmailAddressDetails[]> {
  if (officeIsAppointmentItem()) {
    return officeEventAttendees()
  } else if (officeIsMessageItem()) {
    return officeMailRecipients()
  } else {
    return []
  }
}

async function officeRecipientsEmailAddresses(): Promise<string[]> {
  if (officeIsAppointmentItem()) {
    return officeEventAttendeesEmailAddresses()
  } else if (officeIsMessageItem()) {
    return officeMailRecipientsEmailAddresses()
  } else {
    return []
  }
}

const exportFunctions = {
  get: officeRecipients,
  emailAddresses: officeRecipientsEmailAddresses,
}

export default exportFunctions
